import axios from 'axios'


const formPost = async (data) => {
    let response;
    var config = {
        method: 'post',
        url: process.env.REACT_APP_BASE_URL+'/api/v1/basvuru/create',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        },
        data: data,
    };
    await axios(config)
        .then((res) => {
            
            response = res.data;
        })
        .catch((err) => {
            console.log(err);
        });
    return response;
};

export default formPost;
